import { StepConfig } from '../../dynamicForm/types/fieldTypes';

export const equipmentStep: StepConfig = {
  title: 'Equipment & Features',
  description: 'Add details to attract buyers',
  sections: [
    {
      title: 'Description',
      fields: [
        {
          name: 'description',
          type: 'textarea',
          label: 'Description',
          required: false,
          layout: { span: 24 },
          validations: [
            { type: 'maxLength', message: 'Description cannot exceed 2000 characters', value: 2000 },
          ],
          customProps: {
            placeholder:
              'Describe your vehicle in detail. Include condition, special features, service history, etc.',
            rows: 6,
            maxLength: 2000,
          },
        },
      ],
    },
    {
      title: 'Specs',
      fields: [
        {
          name: 'doors',
          type: 'number',
          label: 'Doors',
          required: false,
          layout: { span: 12 },
          customProps: { placeholder: '4', min: 1, max: 8 },
        },
        {
          name: 'seats',
          type: 'number',
          label: 'Seats',
          required: false,
          layout: { span: 12 },
          customProps: { placeholder: '5', min: 1, max: 12 },
        },
      ],
    },
    {
      title: 'Features & Equipment',
      fields: [
        {
          name: 'features',
          type: 'multiselect',
          label: 'Features',
          required: false,
          layout: { span: 24 },
          api: {
            url: '/api/vehicles/features',
            method: 'GET',
            mapResponse: (data: any) => {
              // Handle array response or data.data wrapper
              const features = Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];
              return features.map((f: any) => ({
                value: f.name,
                label: f.category ? `${f.name} (${f.category})` : f.name,
              }));
            },
          },
          customProps: { placeholder: 'Select all that apply' },
        },
      ],
    },
  ],
  footer: {
    buttons: [
      {
        label: 'Back',
        action: 'back',
        position: 'left',
        variant: 'secondary',
        icon: 'bi-arrow-left',
      },
      {
        label: 'Next: Photos',
        action: 'next',
        position: 'right',
        variant: 'primary',
        icon: 'bi-arrow-right',
      },
    ],
  },
};
